import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import classNames from 'classnames';

import Toast from 'modules/toast';

import Loading from 'modules/loading';

export default class DropZone extends React.Component {
  static propTypes = {
    clientData: PropTypes.object.isRequired,
    handleUploadFile: PropTypes.func.isRequired,
  };

  state = {
    isUploading: false,
  };
  onDrop = (acceptedFiles, rejectedFiles) => {
    // Do something with files

    if (rejectedFiles.length > 0) {
      rejectedFiles.forEach((file) => {
        Toast.error(`Rejected file: ${file.name}`);
      });
    }
    if (acceptedFiles.length > 0) {
      const allUploadPromises = acceptedFiles.map((file) =>
        this.props.handleUploadFile(file),
      );

      this.setState(
        {
          isUploading: true,
        },
        async () => {
          // Call our list of promises here
          await Promise.all(allUploadPromises);
          this.setState({
            isUploading: false,
          });
        },
      );
    }
  };

  render() {
    const baseStyle = {
      width: '100%',
      borderWidth: 2,
      borderColor: '#666',
      borderStyle: 'dashed',
      borderRadius: 5,
      height: 100,
      display: 'flex',
      textAlign: 'center',
      alignItems: 'center',
      justifyContent: 'center',
    };
    const activeStyle = {
      borderStyle: 'solid',
      borderColor: '#6c6',
      backgroundColor: '#eee',
    };
    const rejectStyle = {
      borderStyle: 'solid',
      borderColor: '#c66',
      backgroundColor: '#eee',
    };

    const isUploading = {
      backgroundColor: '#c66',
    };

    return (
      <div>
        <Dropzone onDrop={this.onDrop} disabled={this.state.isUploading}>
          {({ getRootProps, getInputProps, isDragActive, isDragReject }) => {
            let styles = { ...baseStyle };
            styles = isDragActive ? { ...styles, ...activeStyle } : styles;
            styles = isDragReject ? { ...styles, ...rejectStyle } : styles;
            styles = this.state.isUploading
              ? { ...styles, ...isUploading }
              : styles;
            return (
              <div
                {...getRootProps()}
                style={styles}
                className={classNames('dropzone', {
                  'dropzone--isActive': isDragActive,
                })}
              >
                <input {...getInputProps()} />
                {isDragActive ? (
                  <p>Drop files here...</p>
                ) : (
                  <p>
                    Try dropping some files here, or click/tap to select files
                    to upload.
                  </p>
                )}
              </div>
            );
          }}
        </Dropzone>
        {this.state.isUploading && (
          <React.Fragment>
            <Loading inline />
            Loading...
          </React.Fragment>
        )}
      </div>
    );
  }
}
